module.exports = __webpack_public_path__ + "img/Frame_29.2c084d62.png";